import React, { useState, useEffect } from "react";
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
// core components
// import GridItem from "components/Grid/GridItem.js";
// import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";

import MenuItem from "@material-ui/core/MenuItem";

import { formatDate } from "utils/Utils";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
const useStyles = makeStyles(styles);
const innerWidth=window.innerWidth;
export default function Dashboard() {
  const classes = useStyles();
  //const [{ authenticated }, dispatch] = useStateValue(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [filedata, setFileData] = useState([]);
  const [goldpay, setGoldPay] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    "LoanRequestNum",
    "ProposedLoanAmt",
    "Created Date",
    "Select Agent",
    "Actions",
  ]);
  // const [rawData, setRawData] = useState([]);
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);
  const [completeAgentList, setCompleteAgentList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState({});
  const [selectedAgents, setSelectedAgents] = useState({});

  const [userDetailsBranch, setUserDetailsBranch] = useState({});
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [loanDetails, setLoanDetails] = useState({});
  const [showLoanReject, setShowLoanReject] = useState(false);
  const [loanReject, setLoanReject] = useState({});
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
  };
  const closeLoanModal = () => {
    setShowLoanDetails(false);
    setLoanDetails({});
  };

  const closeLoansModal = () => {
    setShowLoanReject(false);
    setLoanReject({});
    GetDashboardData();
  };

  useEffect(() => {
    getUserDetails();
    GetDashboardData();
  }, []);
  const getUserDetails = async () => {
    setUserDetailsBranch(userDetails?.branchCode);
    // setCustomerId(result?.data?.customerId);
  };
  const GetDashboardData = async () => {
    setCallInProgress(true);
    const agentList = await apiHandler({
      url: endpoint.ADMIN_USER_AGENTS,
      authToken: authToken,
    });
    setCallInProgress(false);
    setCompleteAgentList(agentList.data);
    const result = await apiHandler({
      url: endpoint.ADMIN_FINDBYSTATUS + "?status=SUBMITTED",
      authToken: authToken,
    });
    setRawData(result?.data);
    parseIndicatorData(result?.data, agentList.data);
  };
  const parseIndicatorData = (data, agentList) => {
    let reportData = [];
    data &&
      data.applications &&
      data.applications.forEach((goldpay, index) => {
        let row = [
          index,
          getLink(goldpay.id, goldpay.loanRequestNum),
          goldpay.proposedLoanAmt,
          formatDate(goldpay.createdOn),
          getIcons(goldpay.id),
        ];
        reportData.push(row);
      });
    let selectedList = reportData.slice(
      (selectedPageIndex - 1) * rowsPerPage,
      selectedPageIndex * rowsPerPage
    );
    setSelectedTableData(selectedList);
    setTableData(reportData);
  };
  const getLink = (loanApplicationId, link) => {
    return link !== "" ? (
      <a
        style={{ cursor: "pointer" }}
        onClick={() => onLoanDetails(loanApplicationId)}
      >
        {link}
      </a>
    ) : null;
  };
  const onLoanDetails = async (loanApplicationId) => {
    setCallInProgress(true);
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    // Loan Details Modal
    setLoanDetails(result?.data);
    setShowLoanDetails(true);
  };
  const handleChange = (event, loanApplicationId) => {
    //  setCompleteAgentList (event.target.code);
    setSelectedAgent(event.target.value);
    let updatedSelectedAgents = selectedAgents;
    if (event.target.value === "me") {
      const agentdata = {
        id: userDetailsBranch.id,
        mobileNumber: userDetailsBranch.mobileNumber,
      };
      updatedSelectedAgents[loanApplicationId] = agentdata;
    } else {
      updatedSelectedAgents[loanApplicationId] = event.target.value;
    }

    setSelectedAgents(updatedSelectedAgents);
    // console.log(event.target.value);
  };

  const AssignTaskToAgent = async (loanApplicationId) => {
    const selectedSclAgent = selectedAgents[loanApplicationId];
    if (!selectedSclAgent) {
      setNoticeModalErrMsg("Please select Agent first");
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return;
    }
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_APPLICANTIONASSIGN,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        assigneeUserId: selectedSclAgent.id,
        assigneeUserMobileNumber: selectedSclAgent.mobileNumber,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return;
    } else if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return;
    } else {
      // navigate(`/coreservice/gold-rates`);
      setNoticeModalErrMsg("Loan application is assigned to selected Agent");
      setNoticeModalHeaderMsg("Information");
      GetDashboardData();
      setNoticeModal(true);
    }
  };
  const getIcons = (loanApplicationId) => {
    return (
      <>
        <Button
          size="xsmall"
          color="info"
          className="bg-gradient-theme-left border-0"
          disabled={callInProgress}
          onClick={() => AssignTaskToAgent(loanApplicationId)}
        >
          Assign
        </Button>
        <Button
          size="xsmall"
          color="info"
          className="bg-gradient-theme-left border-0"
          disabled={callInProgress}
          style={{ marginLeft: 10 }}
          onClick={() => RejectTaskToAgent(loanApplicationId)}
        >
          Reject
        </Button>
      </>
    );
  };
  const RejectTaskToAgent = (loanApplicationId) => {
    setShowLoanReject(true);
    setLoanReject(loanApplicationId);
  };
  const onSearchChange = (event) => {
    const filteredData = rawData.applications.filter((row) => {
      const val = event.target.value;
      return row.loanRequestNum.toLowerCase().includes(val.toLowerCase());
    });
    parseIndicatorData(
      { count: filteredData.length, applications: filteredData },
      completeAgentList
    );
  };

  const getPageData = (event) => {
    let pageIndex = 0;
    let pageCount = Math.ceil(tableData.length / rowsPerPage);
    switch (event.target.innerText) {
      case "FIRST":
        pageIndex = 1;
        break;
      case "PREVIOUS":
        pageIndex = selectedPageIndex - 1;
        break;
      case "LAST":
        pageIndex = pageCount;
        break;
      case "NEXT":
        pageIndex = selectedPageIndex + 1;
        break;
      default:
        pageIndex = parseInt(event.target.innerText);
        break;
    }
    if (pageIndex < 1) pageIndex = 1;
    else if (pageIndex > pageCount) pageIndex = pageCount;

    let selectedList = tableData.slice(
      (pageIndex - 1) * rowsPerPage,
      pageIndex * rowsPerPage
    );
    setSelectedPageIndex(pageIndex);
    setSelectedTableData(selectedList);
  };
  const getPageDetails = () => {
    let DataCount = Math.ceil(tableData.length / rowsPerPage);
    // switch ()
    let pageArray = [];
    Array.from(new Array(DataCount)).forEach((count, index) => {
      if (index + 1 === selectedPageIndex) {
        pageArray.push({
          text: `${index + 1}`,
          active: true,
        });
      } else {
        pageArray.push({
          text: `${index + 1}`,
        });
      }
    });
    return pageArray;
  };
  return (
    <div>
      <Grid>
        <Grid style={{marginBottom:innerWidth>956?"":"590px"}}>
          <h3 style={{ fontWeight: 500 }}>My Dashboard</h3>
        </Grid>
      </Grid>
    </div>
  );
}
